module.exports = __webpack_public_path__ + "img/9788982738852.de7246ab.jpg";